import { render, staticRenderFns } from "./Sable.vue?vue&type=template&id=0405ac3c"
import script from "./Sable.vue?vue&type=script&lang=js"
export * from "./Sable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports